const initialState = {
    categories: [],
    isCategoryHovered: false,
};

const categories = (state = initialState, action) => {
    switch (action.type) {
        
        case 'CHANGE_DATA_CATEGORIES':
            return {...state, [action.name]: action.value};

        default:
            return state;
    }
};

export default categories;
